export const NO_ACTIVE_CONTRACT = 'No active contract';
